import { HttpInterceptorFn } from "@angular/common/http";
import { inject } from "@angular/core";
import { finalize } from "rxjs";
import { LoadingSpinnerService } from "../services/loading-spinner.service";
import { SKIP_LOADER } from "./skip-loader.context";

export const loaderInterceptor: HttpInterceptorFn = (req, next) => {
  const loadingService = inject(LoadingSpinnerService);
  const skipLoader = req.context.get(SKIP_LOADER);

  if(!skipLoader){
    loadingService.show();
  }

  return next(req).pipe(
    finalize(() => {
      if (!skipLoader) {
        loadingService.hide();
      }
    })
  );
};

// @Injectable()
// export class LoaderInterceptor implements HttpInterceptor{

//     loader = inject(LoadingSpinnerService);

//     intercept(
//         req: HttpRequest<any>, 
//         next: HttpHandler
//     ): Observable<HttpEvent<any>> {
//         this.loader.show();

//         return next.handle(req).pipe(
//             finalize(() => this.loader.hide())
//         );
//     }
    
// }